import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { TechnicalAssistanceInterface } from '../models/technical-assistance.interface';

@Injectable()
export class TechnicalAssistanceService {

  constructor(
      private apiService: ApiService
  ) {}

  /**
   * Get technical assistance credentials
   */
  get(code: string): Observable<TechnicalAssistanceInterface> {
    return this.apiService.get<TechnicalAssistanceInterface>('customer/technical/assistance/credentials/' + code);
  }
}
